import React from 'react';
import type {IconName, IconPrefix} from '@fortawesome/fontawesome-common-types';

import {Icon, Text} from '@albert-io/atomic';

interface Props {
  icon: IconName | [IconPrefix, IconName];
  title: string;
  body: React.ReactNode;
  action?: React.ReactNode;
}

/**
 * Centered roster empty state: an icon in a tinted circle, a title, body copy, and an optional
 * action. Used for "invitations pending" and "no invitations".
 */
export const PeopleEmptyState = ({icon, title, body, action}: Props) => (
  <div className='flex w-full flex-col items-center gap-x2 py-x8 text-center'>
    <span className='flex h-x8 w-x8 items-center justify-center rounded-full background-brand-subtle text-xxl'>
      <Icon color='brand' icon={icon} iconStyle='regular' size='inherit' />
    </span>
    <Text size='l'>{title}</Text>
    <Text className='max-w-[44ch]' color='secondary'>
      {body}
    </Text>
    {action}
  </div>
);
